import { render } from "./BaggingGunReviewModal.vue?vue&type=template&id=3e52a6e0&scoped=true"
import script from "./BaggingGunReviewModal.vue?vue&type=script&lang=js"
export * from "./BaggingGunReviewModal.vue?vue&type=script&lang=js"

import "./BaggingGunReviewModal.vue?vue&type=style&index=0&id=3e52a6e0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e52a6e0"]])

export default __exports__